import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/AxiosInstance";

// ---------------------Signup----------------------------------
export const registerUserApi = async (data) => {
  return await axios.post("user/account", data, setMultiPartHeader());
};

// ---------------------User Interest Questions----------------------------------
export const questionStepperApi = async (data) => {
  return await axios.put("user/update-Interest", data);
};

// ---------------------login----------------------------------
export const loginApi = async (data) => {
  return await axios.post("user/login", data);
};

// ---------------------Verify Otp----------------------------------
export const verifyOtpApi = async (data) => {
  return await axios.post("user/auth/verify-otp", data);
};

// ---------------------Send Otp----------------------------------
export const sendOtpApi = async (data) => {
  return await axios.post("user/auth/send-otp", data);
};

// ---------------------Forgot Password ----------------------------------
export const forgotPasswordApi = async (data) => {
  return await axios.post("user/forget-Password", data);
};

// ---------------------Forgot Password Otp Verification ----------------------------------
export const forgetPasswordOtpVerifyApi = async (data) => {
  return await axios.post("user/forget-Verify-Otp", data);
};

// ---------------------Reset Password-----------------------------------
export const resetPasswordApi = async (data) => {
  return await axios.post("user/otp-Password-Update", data, setJwtToken());
};

//------------User Profile Details API----------------------
export const profileDetailApi = async () => {
  return await axios.get("user/account/my-profile", setJwtToken());
};

//-----------------User Update Profile API---------------------
export const updateUserProfileApi = async (data) => {
  return await axios.put("user/account", data, setMultiPartHeader());
};

// -----------------Delete User Account------------------------
export const deleteUserApi = async (data) => {
  return await axios.delete("user/account", setJwtToken());
};
